import { useState, useEffect } from 'react';
import { team, org } from 'src/backend';
import { isAssignableFoodRunRecipient } from 'src/utils/foodRunRecipient';
import useAuth from './useAuth';

const useRecipientOrganizations = ({ open, currentRecipientTeamId }) => {
  const { user } = useAuth();
  const [recipients, setRecipients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setLoading(true);
      setError('');

      team
        .getMyOrgs('RECIPIENT')
        .then((recipientList) => {
          // Filter out the current recipient
          const filteredRecipients = recipientList.filter(
            (recipient) =>
              recipient.team_id !== currentRecipientTeamId &&
              isAssignableFoodRunRecipient(recipient)
          );

          if (filteredRecipients.length > 0) {
            setRecipients(filteredRecipients);
            setLoading(false);
          } else {
            if (user?.lat && user?.lng) {
              org
                .getNearByNPOs({
                  lat: user.lat,
                  lng: user.lng,
                  includeSelf: true,
                  isDonationCreation: true,
                })
                .then(({ orgs }) => {
                  const filteredNearbyRecipients = orgs.filter(
                    (recipient) =>
                      recipient.team_id !== currentRecipientTeamId &&
                      isAssignableFoodRunRecipient(recipient)
                  );
                  setRecipients(filteredNearbyRecipients || []);
                })
                .catch(() => {
                  setError('Failed to load nearby recipient organizations');
                })
                .finally(() => {
                  setLoading(false);
                });
            } else {
              setRecipients([]);
              setLoading(false);
            }
          }
        })
        .catch(() => {
          setError('Failed to load recipient organizations');
          setLoading(false);
        });
    } else {
      // Reset state when modal closes
      setRecipients([]);
      setError('');
    }
  }, [open, currentRecipientTeamId, user?.lat, user?.lng]);

  return {
    recipients,
    loading,
    error,
  };
};

export default useRecipientOrganizations;
